import type { CountryIso, Phone } from "~/types";

export default function phoneFactory(baseCountry: CountryIso): Phone {
  return {
    code: phoneCodeFactory(baseCountry),
    number: ''
  };
}

function phoneCodeFactory(baseCountry: CountryIso) {
  switch (baseCountry) {
    case 'ISR': return '972';
    case 'SWE': return '46';
    case 'USA': return '1';
    case 'RUS': return '7';
    default: return '1';
  }
}